var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidSelfie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9991 21.9546V24.2273C27.9991 26.5001 27.09 27.4091 24.8173 27.4091H22.09C19.8173 27.4091 18.9082 26.5001 18.9082 24.2273V21.5001C18.9082 19.2273 19.8173 18.3182 22.09 18.3182H24.3627",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6816 22.8181H24.4089",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6816 24.6364H23.4998",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3643 16.8636C18.6237 16.8636 20.4553 15.032 20.4553 12.7727C20.4553 10.5133 18.6237 8.68176 16.3643 8.68176C14.105 8.68176 12.2734 10.5133 12.2734 12.7727C12.2734 15.032 14.105 16.8636 16.3643 16.8636Z",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 25.0455C9.33594 21.8791 12.486 19.3182 16.3641 19.3182C16.7347 19.3182 17.099 19.3415 17.4551 19.3867",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14V10.25C3 6.515 6.015 3.5 9.75 3.5H13.5",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 3.5H26.25C29.985 3.5 33 6.515 33 10.25V14",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24.5V26.75C33 30.485 29.985 33.5 26.25 33.5H24",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 33.5H9.75C6.015 33.5 3 30.485 3 26.75V23",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidSelfie);
export default __webpack_public_path__ + "static/media/bfid-selfie.fddfb227e9deafd31ec2121c7f1efe79.svg";
export { ForwardRef as ReactComponent };